import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Fetches all 48 team documents once and returns them keyed by teamId.
 */
export function useTeams() {
  const [teams, setTeams] = useState({});

  useEffect(() => {
    getDocs(collection(db, 'teams')).then((snap) => {
      const data = {};
      snap.docs.forEach((d) => {
        data[d.id] = { id: d.id, ...d.data() };
      });
      setTeams(data);
    }).catch((err) => console.error('teams fetch error:', err));
  }, []);

  return teams;
}
